module.exports = __webpack_public_path__ + "img/Map.449c77cf.svg";